module.exports = __webpack_public_path__ + "static/york_main_3-83bb7f5abf61ee27a6dfc6ccf1e8eb8d.jpg";